import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=83d32a12&scoped=true&"
import script from "./Landing.js?vue&type=script&lang=js&"
export * from "./Landing.js?vue&type=script&lang=js&"
import style0 from "./Landing.scss?vue&type=style&index=0&id=83d32a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d32a12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCarousel,VCarouselItem,VImg,VLayout,VProgressCircular})
